export default __webpack_public_path__ + "static/media/fitnessChart.50e7e706.png";